const data = {
  studentResult: ['', '阳性', '阴性'],
  studentStatus: ['', '已采血', '检测中', '已报告'],
  genders: ['', '男', '女'],
  logMethods: ['', '增加', '编辑', '删除', '', '', '', '', '', '', '', '登录帐号', '修改密码', ''],
  logScenes: {
    'admin': '管理员',
    'admin_goup': '管理角色',
    'admin_menu': '管理权限',
    'task': '任务'
  }
}
export default {
  data
}